import ApiService from "@/core/services/api.service";

// action types
export const FETCH_COMPANY_PROGRAMS = "fetchCompanyPrograms";

// mutation types
export const SET_COMPANY_PROGRAMS = "setCompanyPrograms";
export const SET_COMPANY_PROGRAMS_PAGINATION = "setCompanyProgramsPagination";

const state = {
  companyPrograms: [],
  companyProgramsPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  }
};

const getters = {
  companyPrograms(state) {
    return state.companyPrograms;
  },
  companyProgramsPagination(state) {
    return state.companyProgramsPagination;
  }
};

const actions = {
  [FETCH_COMPANY_PROGRAMS](context, params = {}) {
    if (params.page === undefined) {
      params.page = context.state.companyProgramsPagination.currentPage;
    }
    return new Promise((resolve, reject) => {
      ApiService.query("company/programs", {
        params: params
      })
        .then(({ data }) => {
          context.commit(SET_COMPANY_PROGRAMS, data.data);
          context.commit(SET_COMPANY_PROGRAMS_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_COMPANY_PROGRAMS](state, companyPrograms) {
    state.companyPrograms = companyPrograms;
  },
  [SET_COMPANY_PROGRAMS_PAGINATION](state, data) {
    state.companyProgramsPagination = data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
